import { FC } from 'react';

export const ActivityIcon: FC<{ className?: string }> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 100 100"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
    >
        <polyline
            points="10,50 30,30 50,70 70,20 90,50"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
